import React, { Component } from 'react';
import { Message, Button, Grid, Form, Segment } from 'semantic-ui-react';
import { Redirect } from 'react-router-dom';
import withDataConsumer from '../../api/contextApi/withDataConsumer';

class Login extends Component {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);

    this.state = {};
  }

  onChange = (e, { value }) => {
    this.setState({ password: value });
  }

  submitForm = () => {
    if (this.state.password === 'admin@JTV2018') {
      this.props.context.login();
      this.setState({ redirect: true });
    } else {
      this.setState({ error: true });
    }
  }

  render() {
    const { error, redirect, password } = this.state;
    if (redirect) {
      return <Redirect to="/admin/message" />;
    }
    return (
      <Grid textAlign="center" style={{ height: '100%' }} verticalAlign="middle">
        <Grid.Column style={{ maxWidth: 450 }}>
          <Form size="large" onSubmit={this.submitForm}>
            <Segment stacked>
              <Form.Input
                name="password"
                value={password}
                fluid
                icon="lock"
                iconPosition="left"
                placeholder="Password"
                type="password"
                label="Geef het admin password op."
                onChange={this.onChange}
              />
              <Button color="teal" fluid size="large">
                Login
              </Button>
              {error && (
              <Message
                error
                fluid
                content="Verkeerd password opgegeven"
              />
              )}
            </Segment>
          </Form>
        </Grid.Column>
      </Grid>
    );
  }
}

export default withDataConsumer(Login);



// WEBPACK FOOTER //
// ./src/components/Admin/Login.js